<span *ngIf="multiple"><mat-pseudo-checkbox class="mat-option-pseudo-checkbox" [state]="selected ? 'checked' : ''" [disabled]="disabled"></mat-pseudo-checkbox></span><ng-content></ng-content><div class="mat-option-ripple" mat-ripple [matRippleTrigger]="_getHostElement()" [matRippleDisabled]="disabled || disableRipple"></div>


// WEBPACK FOOTER //
// ./node_modules/@angular/material/core/typings/index.d.ts.MdOption.html